<template>
  <div class="group-contact">
    <span
    :class="isAdmin && 'pointer'"
    class="group-contact__text group-contact__text_light"
    @click="openEditor">
      {{ isEmptyData ? '—' : contact }}
    </span>

    <transition name="fade">
      <div
      v-if="showEditor"
      v-click-outside="onClickOutside"
      class="group-contact__editor">
        <div class="group-contact__editor-element">
          <span class="group-contact__text_light">
            {{ $t('Edit a contact') }}
          </span>
          <input
          v-model="contactValue"
          type="text"
          :placeholder="$t('Specify the contact')"
          class="group-contact__input">
        </div>
        <TJButton
        :text="$t('save')"
        type="text"
        @handler="saveChanges" />
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'GroupContact',
  props: {
    hideDetails: {
      type: Boolean,
      default: false,
    },
    isAdmin: {
      type: Boolean,
      default: false,
    },
    group: {
      type: Object,
      default: null,
    },
    contact: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    showEditor: false,
    contactValue: null,
  }),
  methods: {
    openEditor() {
      if (!this.isAdmin) {
        return;
      }
      this.contactValue = this.contact;
      this.showEditor = true;
    },
    closeEditor() {
      this.showEditor = false;
      this.contactValue = null;
    },
    onClickOutside() {
      this.closeEditor();
    },
    saveChanges() {
      const newData = {
        contact: this.contactValue === '' ? null : this.contactValue,
      };

      this.showEditor = false;

      this.$store.dispatch('groups/groupUpdate', { id: this.group.id, social: this.group.social, newData })
        .then(() => {
          this.group.contact = this.contactValue === '' ? null : this.contactValue;
          this.$store.dispatch('app/setSnackBar', { text: this.$t('Data updated'), error: false });
        })
        .catch(() => {
          this.$store.dispatch('app/setSnackBar',
            {
              text: this.$t('An error occurred while updating the data'),
              error: true,
            });
        });
    },
  },
  computed: {
    isEmptyData() {
      return this.contact === null || this.contact === '';
    },
  },
};
</script>

<style lang="scss" scoped>
.group-contact {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  width: 180px;
  min-height: 50px;
  position: relative;
}

.group-contact__text {
  font-size: 14px;
  padding: 15px 10px;
  color: $primary-gray;
  text-align: center;
  word-break: break-all;
  &_light {
    font-size: 12px;
    color: $primary-lightgray;
  }
}

.group-contact__editor {
  position: absolute;
  top: 0px;
  left: 30px;
  min-width: 200px;
  border-radius: 12px;
  padding: 20px 20px 0px;
  box-shadow: 0px 0px 10px 1px rgb(34 60 80 / 10%);
  background: $primary-white;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  @include between-elements {
    margin-bottom: 10px;
  }
}

.group-contact__editor-element {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  @include between-elements {
    margin-bottom: 5px;
  }
}

.group-contact__input {
  padding: 5px 10px;
  border: 1px solid $primary-lightgray;
  border-radius: 8px;
  font-size: 12px;
  &:focus {
    outline: none;
  }
  &::placeholder {
    font-size: 12px;
    color: $primary-lightgray;
  }
}

</style>
